// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { shipmentPackagesStyles } from "@gcg/Overrides/Widgets/OrderDetails/OrderDetailsShipmentPackages";
import { screen } from "@gcg/XDL/Helpers";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

shipmentPackagesStyles.showAccordionGridStyle = {
    width: 12,
    css: css`
        padding: 0;
        ${screen("lte", "md")`
            &.hide-on-mobile {
                display:none;
            }
        `}
    `,
};
shipmentPackagesStyles.shippingDetailsStyle = {
    color: "primary.main",
    typographyProps: {
        size: "16px",
    },
    css: css`
        border-color: ${getColor("primary.main")};
        &.hide-on-desktop {
            margin-bottom: 20px;
        }
        ${screen("gt", "md")`&.hide-on-desktop { display:none; }`}
        ${screen("lte", "md")`
            width: 90%;
            text-align: center;
            flex-direction: row-reverse;
            justify-content: center;
            padding: 3px;
            border-width: 1px;
            border-style: solid;
        `};
    `,
};
shipmentPackagesStyles.deliveryLinkStyle = {
    color: "primary.main",
    typographyProps: {
        size: "16px",
    },
};
shipmentPackagesStyles.accordionCellStyle = {
    css: css`
        padding: 5px 0;
        cursor: auto;
        ${screen("lte", "md")`
            height: 100%;
        `}
    `,
};
